import { Address } from '@app/@theme/google-map/models/address';

export class Location {
  address: string;
  city: string;
  state: string;
  zipCode: number;
  country: string;
  latitude: number;
  longitude: number;

  constructor(
    address?: string,
    city?: string,
    state?: string,
    zipCode?: number,
    country?: string,
    latitude?: number,
    longitude?: number) {
    this.address = address;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.country = country;
    this.latitude = latitude;
    this.longitude = longitude;
  }
  static getGmapAddress(event: Address) {
    const location = new Location(
      event.streetNumber + ' ' + event.streetName + (event.subpremise ?  ` #${event.subpremise}` : ''),
      event.locality.long !== undefined ? event.locality.long : event.sublocality,
      event.state !== undefined ? event.state.long : '',
      event.postalCode,
      event.country !== undefined ? event.country.long : '',
      event.geoLocation.latitude,
      event.geoLocation.longitude);
    return location;
  }
}
